import explosUrl from '../assets/GHS_PICTOGRAMS/GHS-pictogram-explos.svg?url';
import flammeUrl from '../assets/GHS_PICTOGRAMS/GHS-pictogram-flamme.svg?url';
import rondFlamUrl from '../assets/GHS_PICTOGRAMS/GHS-pictogram-rondflam.svg?url';
import bottleUrl from '../assets/GHS_PICTOGRAMS/GHS-pictogram-bottle.svg?url';
import acidUrl from '../assets/GHS_PICTOGRAMS/GHS-pictogram-acid.svg?url';
import skullUrl from '../assets/GHS_PICTOGRAMS/GHS-pictogram-skull.svg?url';
import exclamUrl from '../assets/GHS_PICTOGRAMS/GHS-pictogram-exclam.svg?url';
import silhouetteUrl from '../assets/GHS_PICTOGRAMS/GHS-pictogram-silhouette.svg?url';
import polluUrl from '../assets/GHS_PICTOGRAMS/GHS-pictogram-pollu.svg?url';

export interface GhsPictogram {
  code: string;
  labelKey: string;
  svgUrl: string;
}

export const GHS_PICTOGRAMS: GhsPictogram[] = [
  { code: 'GHS01', labelKey: 'ghsPictograms.GHS01', svgUrl: explosUrl },
  { code: 'GHS02', labelKey: 'ghsPictograms.GHS02', svgUrl: flammeUrl },
  { code: 'GHS03', labelKey: 'ghsPictograms.GHS03', svgUrl: rondFlamUrl },
  { code: 'GHS04', labelKey: 'ghsPictograms.GHS04', svgUrl: bottleUrl },
  { code: 'GHS05', labelKey: 'ghsPictograms.GHS05', svgUrl: acidUrl },
  { code: 'GHS06', labelKey: 'ghsPictograms.GHS06', svgUrl: skullUrl },
  { code: 'GHS07', labelKey: 'ghsPictograms.GHS07', svgUrl: exclamUrl },
  { code: 'GHS08', labelKey: 'ghsPictograms.GHS08', svgUrl: silhouetteUrl },
  { code: 'GHS09', labelKey: 'ghsPictograms.GHS09', svgUrl: polluUrl },
];

export const GHS_PICTOGRAM_MAP = Object.fromEntries(GHS_PICTOGRAMS.map((p) => [p.code, p]));
